import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IFileData, IFilesProps, IFilesState } from '../../models/pages/files';
import moment from 'moment';
import 'moment/locale/en-gb';
import 'moment/locale/tr';
import 'moment/locale/ar';
import { Modal, Table } from 'reactstrap';
import { Common } from '../../core/common';
import Translator from '../../core/i18n';
import { FileUpload } from '../../components/file-upload/main';
import Paginate from '../../components/table/paginate';
import { SelectNoneAsync } from '../../components/input/select/main';
import { IAction, IAppState } from '../../models/action/core';
import { Log } from 'ng2-logger';
import * as Actions from "../../store/actions/files";
import { newNotification } from '../../store/actions/core';
import { Guid } from 'guid-typescript';
import Input from '../../components/input/text/input-formik';
import { Formik, FormikActions, FormikProps } from 'formik';
import { FileOwnerType } from '../../models/enums/FileOwnerType';
import Tooltip from '../../components/tooltip/main';
import Truncater from '../../components/truncater/main';

const T = Translator.create();
const _logger = Log.create('Files - main.tsx');
let _common: Common;
const date = new Date()

class CMyFilesPage extends React.Component<IFilesProps, IFilesState> {

     uppyInstance: any;

     constructor(props: IFilesProps) {
          super(props);

          moment.locale(T.i18next.language);
          _common = new Common();
          this.addNewFileModal = this.addNewFileModal.bind(this);
          this.setCloseFileModal = this.setCloseFileModal.bind(this);

          this.onSubmit = this.onSubmit.bind(this);
          this.state = {
               isAddFileModalOpen: false,
               isModalOpen: true,
               isFileSharingType: 1,
               fileUploadKey: Guid.create().toString(),
               photoUploadKey: Guid.create().toString(),
               fileUploaded: false,
               showFileUploaderCount: 0,
               isFirstLoad: true,
               selectedFileIds: [],
               disAllowedFileIds: [],
               isAll: false,
               filters: {
                    page: 1,
                    take: 10,
                    total: 0,
                    skip: 0,
                    query: "",
                    orderBy: "-",
                    select_all: false
               },
               filterInitialValues: {
                    includeMyFiles: true,
                    includeSharedFiles: true,
                    searchedText: "",
                    searchedUser: "",
                    page: 1,
                    take: 10
               },
               fileUploadTypes: this.getFileUploadTypes(),
               isLoadingProcess: false
          };
     }

     componentDidMount(): void {
          this.getMyFiles()
          this.updateFileUploadTypes();
     }

     getFileUploadTypes = () => {
          return [
               { value: 0, label: T.t('r_files_private') },
               { value: 1, label: T.t('r_files_shared') },
               { value: 2, label: T.t('r_gen_all') }
          ];
     }

     updateFileUploadTypes = () => {
          this.setState({
               fileUploadTypes: this.getFileUploadTypes()
          });
     }

     setInitialFilters = () => {
          if (this.props.myFiles?.filters) {
               this.setState((prevState: IFilesState) => ({
                    isFirstLoad: false,
                    filters: {
                         ...prevState.filters,
                         total: this.props.myFiles?.filters?.total ?? 0,
                         page: this.props.myFiles?.filters?.page ?? 1
                    }
               }))
          }
     }

     onSelectFile = (event: React.ChangeEvent<HTMLInputElement>) => {
          if (event?.target) {
               if (!this.state.isAll) {
                    const selectedIds = Object.assign([], this.state.selectedFileIds);
                    const id: string = event.currentTarget.dataset.id ?? '';
                    if (event.target.checked && id) {
                         selectedIds.push(id);
                    } else if (!event.target.checked && id) {
                         const index = selectedIds.indexOf(id);
                         if (index !== -1) {
                              selectedIds.splice(index, 1);
                         }
                    }
                    this.setState({ selectedFileIds: selectedIds });
               } else {
                    const disAllowedIds = Object.assign([], this.state.disAllowedFileIds);
                    const id: string = event.currentTarget.dataset.id ?? '';
                    if (!event.target.checked && id) {
                         disAllowedIds.push(id);
                    } else if (event.target.checked && id) {
                         const index = disAllowedIds.indexOf(id);
                         if (index !== -1) {
                              disAllowedIds.splice(index, 1);
                         }
                    }
                    this.setState({ disAllowedFileIds: disAllowedIds });
               }
          }
     };

     public addNewFileModal() {
          this.setState({ isAddFileModalOpen: true });
     }

     public setCloseFileModal() {
          this.setState({ isAddFileModalOpen: false, isLoadingProcess: false });
     }

     fileUploadedStartUppy = (uppy: any) => {
          this.uppyInstance = uppy;
     };

     handleFileUploaded = (uppy: any) => {
          this.fileUploadedStartUppy(uppy);
          this.fileUploadedHandler(uppy);
     };

     fileUploadedHandler = (uppy: any) => {

          this.setState({
               fileUploaded: true,
               showFileUploaderCount: Object.keys(uppy.store.state.files).length
          });
     };

     deleteFileAfter = () => {
          this.setState({
               fileUploaded: false,
               showFileUploaderCount: 0
          });
     }

     public renderFileUpload = () => {
          return (
               <div className="upload-image text-center mb-1">
                    <FileUpload
                         key={this.state.fileUploadKey}
                         height={300}
                         maxFileSize={2000000000}
                         maxSelectedFileCount={1}
                         isCardImage={false}
                         fileTypes={window.appSettings.FileUploadAllowedTypes}
                         fileInputKey={this.state.fileUploadKey}
                         setFile={''}
                         formik={this.props.formik}
                         triggerFileUpload={this.handleFileUploaded}
                         afterDeleted={this.deleteFileAfter}
                    />
               </div>
          )
     }

     addNewFile = () => {
          this.setState({ isLoadingProcess: true })
          if (this.state.fileUploaded) {
               this.props.dispatch(Actions.AddMyFilesAction(this.state.fileUploadKey, this.state.photoUploadKey, this.state.isFileSharingType === 2 ? FileOwnerType.User : FileOwnerType.Organization, "AddMyFilesAction", "", () => {
                    this.setCloseFileModal()
                    this.getMyFiles()
               }));
          } else {
               this.props.dispatch(newNotification(T.t('r_must_file_upload'), '', '', 'topRight', 'error'))
               this.setState({ isLoadingProcess: false })
          }
     }

     public clickToDownload = (filepath: string, filename?: string) => {
          if (filepath && filename) {
               _common.DownloadLink(filepath + '/download', filename);
          }
     };

     public handleFileSharingTypeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
          const value = parseInt(event.target.value);
          this.setState({ isFileSharingType: value });
     }

     selectAll = (event: React.ChangeEvent<HTMLInputElement>) => {
          if (event?.target) {
               this.setState({ isAll: event.target.checked });
               if (!event.target.checked) {
                    this.setState({ disAllowedFileIds: [] });
               }
          }
     }

     onSubmit = (values: any, formikActions: FormikActions<any>) => {
          this.setState((prevState: IFilesState) => ({
               filterInitialValues: {
                    searchedText: values.searchedText ?? "",
                    searchedUser: values.searchedUser ?? "",
                    includeSharedFiles: values.includeSharedFiles ?? prevState.filterInitialValues.includeSharedFiles,
                    includeMyFiles: values.includeMyFiles ?? prevState.filterInitialValues.includeMyFiles,
                    page: 1,
                    take: 10
               }
          }), () => this.getMyFiles())

          formikActions.setSubmitting(false);
     };

     onPageChange = async (page: number) => {
          this.setState((prevState: IFilesState) => ({
               filterInitialValues: {
                    ...prevState.filterInitialValues,
                    page: page,
               },
               filters: {
                    ...prevState.filters,
                    page: page
               }
          }), () => this.getMyFiles());
     };

     getMyFiles = () => {
          this.props.dispatch(Actions.GetMyFilesAction(this.state.filterInitialValues, "GetMyFilesAction", "get", () => this.setInitialFilters()));
     }


     public onChangeSelectCondition(selectValue: any, formik: FormikProps<any>) {
          if (selectValue) {
               switch (selectValue.value) {
                    case 0:
                         formik.setFieldValue('includeSharedFiles', false);
                         formik.setFieldValue('includeMyFiles', true);
                         break;
                    case 1:
                         formik.setFieldValue('includeSharedFiles', true);
                         formik.setFieldValue('includeMyFiles', false);
                         break;
                    case 2:
                    default:
                         formik.setFieldValue('includeSharedFiles', true);
                         formik.setFieldValue('includeMyFiles', true);
                         break;
               }

          } else {
               formik.setFieldValue('includeSharedFiles', true);
               formik.setFieldValue('includeMyFiles', true);
          }
     }

     returnIconNameForExtension = (extension: string) => {
          let iconClassName = "";
          switch (extension.toLowerCase()) {
               case ".pdf":
                    iconClassName = "pdf";
                    break;
               case ".docx":
               case ".doc":
                    iconClassName = "word";
                    break;
               case ".xlsx":
               case ".xls":
                    iconClassName = "excel";
                    break;
               case ".ppt":
                    iconClassName = "ppt";
                    break;
               case ".png":
               case ".jpg":
               case ".jpeg":
               case ".svg":
                    iconClassName = "png";
                    break;
               case ".mp4":
               case ".avi":
                    iconClassName = "video";
                    break;
               default:
                    iconClassName = extension;
                    break;
          }

          return iconClassName;
     }

     renderFilesData = (file: IFileData) => {

          let iconClassName = this.returnIconNameForExtension(file.extension);

          let convertedFileSize = _common.BytesToSize(file.size ?? 0);

          return (
               <tr>
                    {/* <td> */}
                    {/* <div className="col-sm-6 tick-radio text-md-right mt-sm-0 mt-3">
                              <div >
                                   <input
                                        data-id={file.fileId}
                                        disabled={false}
                                        type="checkbox"
                                        name="isAll"
                                        id="isAll"
                                        className="form-radio"
                                        onChange={ this.onSelectFile }
                                        checked={(!this.state.isAll && this.state.selectedFileIds?.includes(file.fileId!)) || (this.state.isAll && !this.state.disAllowedFileIds?.includes(file.fileId!))} />
                              </div>
                         </div> */}
                    {/* </td> */}

                    {/* <td className={(!_common.isArabic(file.fileName, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')} style={{ alignContent: 'baseline', overflow: "unset" }} onClick={() => this.clickToDownload(file.filePath, file.fileName)}>
                         <Tooltip data={file.fileName} position='top'>
                              <Truncater length={42} text={file.fileName || ''} as='span'></Truncater>
                         </Tooltip>
                    </td> */}

                    <td style={{ alignContent: 'baseline', overflow: "unset" }} onClick={() => this.clickToDownload(file.filePath, file.fileName)}>
                         <Tooltip data={file.fileName} position={document.body.getAttribute('dir') == 'ltr' ? 'right' : 'left'}>
                              <span className='text-truncate d-block' style={{ maxWidth: '100px' }}>{file.fileName}</span>
                         </Tooltip>
                    </td>
                    <td style={{ alignContent: 'baseline',overflow: "unset"  }}>
                         <Tooltip data={file.extension} position={document.body.getAttribute('dir') == 'ltr' ? 'top' : 'top'} widthValue='100%'>
                              {!(iconClassName.includes(".")) ? (
                                   <><span style={{ pointerEvents: 'auto' }} className={`document-type-icon ${iconClassName}`}></span>
                                   </>
                              ) : (
                                   <span className="document-type-icon">{iconClassName}</span>
                              )}
                         </Tooltip>
                    </td>
                    <td>{moment(file.createdDate).format("DD.MM.YYYY HH:mm")}</td>
                    <td>{convertedFileSize}</td>
                    <td>{this.state.fileUploadTypes[file.uploadCategory].label}</td>
                    <td style={{ alignContent: 'baseline', overflow: "unset" }} className={(!_common.isArabic(file.nameSurname, document.body.getAttribute('dir')) ? ' arabic-text-direction' : '')} >
                         <Tooltip data={file.nameSurname} position='top'>
                              <span className='text-truncate d-block' style={{ maxWidth: '100px' }}>{file.nameSurname}</span>
                         </Tooltip>
                    </td>
               </tr>
          )

     }

     public render() {
          return (
               <>
                    <div className="container pd-top-30 ">
                         <div className="row">
                              <div className="col-md-4 col-12">
                                   <h6 className="m-pl-2 mb-md-0 page-header">{T.t('r_menu_my_documents')}</h6>
                              </div>
                              <div className="col-md-8 col-12 text-right d-flex justify-content-end">

                                   <div className="options d-inline-flex justify-content-end align-items-center">
                                        <button onClick={this.addNewFileModal.bind(this)} type="button" className="ml-2 category-tag-square tag-green  ">
                                             <i className="material-icons mr-1 ">add</i>
                                             {T.t('r_fileUpload_dashboardTitle')}
                                        </button>
                                   </div>
                              </div>
                         </div>
                         <div className="row">
                              <div className="col-12">
                                   <div className="filter-fields mt-4">
                                        <Formik initialValues={this.state.filterInitialValues} onSubmit={this.onSubmit}>
                                             {(formik: any) => {
                                                  return (
                                                       <form onSubmit={formik.handleSubmit}>
                                                            <div className="row mt-1 align-items-baseline pl-1 pr-3">
                                                                 <div className="col-md-4 col-12">
                                                                      <div className="form-input form-group date-picker mb-3">
                                                                           <Input
                                                                                type={'text'}
                                                                                name={'searchedText'}
                                                                                label={T.t('r_gen_search')}
                                                                                formik={formik}
                                                                           />
                                                                      </div>
                                                                 </div>
                                                                 <div className="col-md-4 col-12">
                                                                      <div className="form-input form-group date-picker mb-3">
                                                                           <Input
                                                                                type={'text'}
                                                                                name={'searchedUser'}
                                                                                label={T.t('r_files_uploader')}
                                                                                formik={formik}
                                                                                required={false}
                                                                           />
                                                                      </div>
                                                                 </div>

                                                                 <div className="col-md-4 col-12">
                                                                      <div className="form-input form-group date-picker mb-3">
                                                                           <SelectNoneAsync
                                                                                name={'fileUploadTypes'}
                                                                                touched={formik.touched.questionTypes}
                                                                                errors={formik.errors.questionTypes}
                                                                                setFieldValue={formik.setFieldValue}
                                                                                setOptions={this.state.fileUploadTypes}
                                                                                onChange={(e: any) => this.onChangeSelectCondition(e, formik)}
                                                                                isTouched={formik.setFieldTouched}
                                                                                placeHolder={T.t('r_files_upload_type')}
                                                                                isMulti={false}
                                                                                isClearable={true}
                                                                           />
                                                                      </div>
                                                                 </div>
                                                                 <div className=" col-12">
                                                                      <div className="text-right my-2 ">
                                                                           <button className="ml-2 category-tag-square tag-green">
                                                                                {T.t('r_gen_search')} <i className="material-icons ml-2">search</i>
                                                                           </button>
                                                                      </div>
                                                                 </div>
                                                            </div>
                                                       </form>
                                                  );
                                             }}
                                        </Formik>

                                   </div>
                              </div>
                         </div>
                         {
                              this.props.myFiles?.results && this.props.myFiles?.results.length > 0 ?
                                   <div className="row">
                                        <div className="col-12">
                                             <div className="page-table helpDesk-table p-0 m-t-0" id="getHelpDesktList_Content">
                                                  <Table
                                                       className="table-user-list table-striped table-ellipsis table-mobile mt-4 table-clickable"
                                                       striped={true}
                                                       hover={true}
                                                       borderless={true}
                                                  >
                                                       <thead>
                                                            <tr style={{ backgroundColor: '#eaeaea' }}>
                                                                 {/* <th style={{ width: '56px' }}> */}
                                                                 {/* <div className="col-sm-6 tick-radio text-md-right mt-sm-0 mt-3">
                                                                           <div >
                                                                                <input
                                                                                     disabled={false}
                                                                                     type="checkbox"
                                                                                     name="isAll"
                                                                                     id="isAll"
                                                                                     className="form-radio"
                                                                                     onChange={this.selectAll} />
                                                                           </div>
                                                                      </div> */}
                                                                 {/* </th> */}
                                                                 <th>{T.t('r_files_name')}</th>
                                                                 <th className='text-center'>{T.t('r_files_type')}</th>
                                                                 <th>{T.t('r_files_date')}</th>
                                                                 <th>{T.t('r_files_size')}</th>
                                                                 <th>{T.t('r_files_upload_type')}</th>
                                                                 <th>{T.t('r_files_uploader')}</th>
                                                            </tr>
                                                       </thead>
                                                       <tbody>
                                                            {this.props.myFiles.results.map((file: IFileData) =>
                                                                 this.renderFilesData(file)
                                                            )}

                                                       </tbody>
                                                  </Table>

                                                  <div className="row-options justify-content-end">
                                                       <div
                                                            className="page-sorting d-flex align-items-center justify-content-center"
                                                            style={{ marginTop: '5px' }}
                                                       />
                                                       <Paginate
                                                            class={'custom-paginate'}
                                                            filters={this.state.filters}
                                                            onPageChange={this.onPageChange} />
                                                  </div>
                                             </div>


                                        </div>
                                   </div>
                                   : <div className="col-12 mt-5">
                                        <div className="not_found">
                                             <img src={_common.GetDefaultImages('_not_found')} alt="" />
                                             <span>{T.t('r_no_results_found')}</span>
                                        </div>
                                   </div>
                         }


                    </div>
                    <Modal
                         isOpen={this.state.isAddFileModalOpen}
                         toggle={this.setCloseFileModal}
                         modalClassName={'add-activity-modal modal-from-right slideInRight show animated'}
                         fade={true}
                         style={{ display: 'block', animationDuration: '0.5s' }}
                         backdrop={"static"}
                         id={'add_new_activity'}
                    >
                         <div className="modal-dialog" style={{ width: '40vw', height: window.innerHeight }}>
                              <div className="modal-content" style={{ height: window.innerHeight }}>
                                   <div className="modal-header d-flex justify-content-start">
                                        <h5 className="modal-title d-flex align-items-center">{T.t('r_fileUpload_dashboardTitle')}</h5>
                                        <button
                                             onClick={this.setCloseFileModal}
                                             type="button"
                                             className="close"
                                             data-dismiss="modal"
                                             aria-label="Close"
                                        >
                                             <i style={{ color: '#000' }} className="material-icons">
                                                  close
                                             </i>
                                             <span>{T.t('r_gen_close')}</span>
                                        </button>
                                   </div>
                                   <div className="modal-body p-3">
                                        <div className="row mt-0 mr-0 ml-0">
                                             <div className="col-md-6 pr-0">
                                                  <div className="radio-tabs tick-radio position-relative">
                                                       <input
                                                            type="radio"
                                                            name={'completionType'}
                                                            checked={this.state.isFileSharingType === 1}
                                                            value={'1'}
                                                            id="radio-filesShared"
                                                            className='form-radio'
                                                            onChange={this.handleFileSharingTypeChange}
                                                       />
                                                       <label htmlFor="radio-filesShared">{T.t('r_files_shared')}</label>
                                                  </div>
                                             </div>
                                             <div className="col-md-6 pl-0">
                                                  <div className="radio-tabs tick-radio position-relative mt-md-0 mt-3">
                                                       <input
                                                            type="radio"
                                                            name={'completionType'}
                                                            checked={this.state.isFileSharingType === 2}
                                                            className='form-radio'
                                                            id="radio-filesPrivate"
                                                            value={'2'}
                                                            onChange={this.handleFileSharingTypeChange}
                                                       />
                                                       <label htmlFor='radio-filesPrivate'>{T.t('r_files_private')}</label>
                                                  </div>
                                             </div>
                                             <div className="col-12 add-document">
                                                  {this.renderFileUpload()}
                                             </div>
                                        </div>
                                   </div>
                                   <div className="modal-footer d-block">
                                        <div className="row">
                                             <div className="col-md">
                                                  <button onClick={this.setCloseFileModal} type='button' className='btn btn-gray ml-2 mobile-activity-regulation-btn'>{T.t('r_cancel_button')}</button>
                                             </div>
                                             <div className="col-md text-md-right">
                                                  <button onClick={this.addNewFile} type='button' className='btn btn-success ml-2'>
                                                       {this.state.isLoadingProcess ? T.t('r_gen_saving') : T.t('r_gen_save')}
                                                  </button>
                                             </div>
                                        </div>
                                   </div>
                              </div>
                         </div>
                    </Modal>
               </>
          );
     }
}


const mapStateToProps = (state: IAppState, ownProps: IFilesProps): IFilesProps => {
     if (!state) {
          return ownProps;
     }

     const newProps: IFilesProps = Object.assign({}, ownProps, {
          myFiles: state.files.myFiles,
          userId: state.login.identitiy.userId,
          userType: state.login.identitiy.userType
     });
     return newProps;
};

const areStatesEqual = (next: IAppState, prev: IAppState) => {
     const ret = next.files.myFiles === prev.files.myFiles &&
          next.login.identitiy.userId === prev.login.identitiy.userId &&
          next.login.identitiy.userType === prev.login.identitiy.userType
     return ret;
};
const dispatchProps = (dispatch: Dispatch<IAction>) => {
     return {
          dispatch
     };
};

const MyFilesPage = connect(
     mapStateToProps,
     dispatchProps,
     null,
     {
          areStatesEqual
     }
)(CMyFilesPage);

export default MyFilesPage;
